<template>
  <div class="flex flex-wrap w-full relative justify-between" :style="{ gap: props.gap }">
    <div v-for="index in count" :key="index" :class="cardWidthClass + ' ' + (index === 2 ? 'skeleton-card-1' : '') + ' ' + (index === 3 ? 'skeleton-card-2' : '')" class="skeleton-card">
      <!-- 头像/图片占位 -->
      <div class="skeleton-avatar" ></div>

      <!-- 标题占位 -->
      <div class="skeleton-title"></div>

      <div class="flex flex-wrap gap-2 justify-between">
        <!-- 描述文本占位 -->
        <div class="skeleton-text skeleton-text-1"></div>
        <div class="skeleton-text skeleton-text-1"></div>
        <div class="skeleton-text skeleton-text-1"></div>
        <div class="skeleton-text skeleton-text-2" v-if="index % 2 === 0"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// 定义组件 props
interface Props {
  // 显示的卡片数量
  count?: number
  // 每行显示的卡片数量 (1-4)
  columnsPerRow?: 1 | 2 | 3 | 4
  // 卡片间距
  gap?: string
}

const props = withDefaults(defineProps<Props>(), {
  count: 4,
  columnsPerRow: 2,
  gap: '6px'
})

// 计算卡片宽度类名
const cardWidthClass = computed(() => {
  const widthMap = {
    1: 'w-full',      // 100%
    2: 'w-[calc(50%-6px)]',  // 每行2个，减去间距
    3: 'w-[calc(33.333%-11px)]', // 每行3个，减去间距
    4: 'w-[calc(25%-12px)]'   // 每行4个，减去间距
  }
  return widthMap[props.columnsPerRow]
})
</script>

<style lang="scss" scoped>
.skeleton-card {
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-avatar {
  width: 100%;
  height: 245px;
  background: linear-gradient(90deg, #3a3d5c 25%, #484b6a 50%, #3a3d5c 75%);
  background-size: 200% 100%;
  border-radius: 12px;
  animation: shimmer 1.5s infinite;
}
.skeleton-card-1{
  position: absolute;
  width: 171px;
    top: 320px;
    left: 0px;
    // width: 45px;
}
.skeleton-card-2{
  position: absolute;
  width: 171px;
    top: 350px;
    left: 182px;
    // width: 45px;
}

.skeleton-title {
  width: 100%;
  height: 24px;
  background: linear-gradient(90deg, #3a3d5c 25%, #484b6a 50%, #3a3d5c 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
}

.skeleton-text {
  height: 20px;
  background: linear-gradient(90deg, #3a3d5c 25%, #484b6a 50%, #3a3d5c 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;

  &.skeleton-text-1 {
    width: 45px;
  }
  &.skeleton-text-3 {

  }

  &.skeleton-text-2 {
    width: 69px;
    height: 18px;
    // background: #FFFFFF;
    border-radius: 9px;
  }
}

// 闪烁动画
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

// 整体脉冲动画
@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.8;
  }
}
</style>
